import React from "react";
import ReactDOM from "react-dom/client";
import "./utils/api";
import App from "./App.js";
import "./index.css";
import { BrowserRouter } from "react-router-dom";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// Register PWA Service Worker for offline and fast loading
serviceWorkerRegistration.register();
